import { Component } from '@angular/core';
import { TranslocoDirective, TranslocoModule } from '@jsverse/transloco';
import { UserManagementOverviewComponent } from '../../../domains/organization/user/components/user-management-overview/user-management-overview.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-team-container',
  imports: [
    TranslocoModule,
    TranslocoDirective,
    UserManagementOverviewComponent,
    RouterOutlet,
  ],
  templateUrl: './team-container.component.html',
})
export class TeamContainerComponent {}
